import { render, staticRenderFns } from "./BraceletView.vue?vue&type=template&id=d5ef2dc6&scoped=true&"
import script from "./BraceletView.vue?vue&type=script&lang=js&"
export * from "./BraceletView.vue?vue&type=script&lang=js&"
import style0 from "./BraceletView.vue?vue&type=style&index=0&id=d5ef2dc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5ef2dc6",
  null
  
)

export default component.exports